import React, { Component } from 'react';
import LoadableComponent from '../../common-components/PlaceholderLoading/LoadableComponent';
import NoColContentLoadPlaceholder from '../../common-components/PlaceholderLoading/Templates/Content/NoColContentLoadPlaceholder';
import NoColContentLoadErrorPlaceholder from '../../common-components/PlaceholderLoading/Templates/Content/NoColContentLoadErrorPlaceholder';
import { Translation } from "react-i18next";
import { LoadScript } from '../../types/LoadScript'
import { Configuration } from '../../types/Configuration'

type Props = {
    configuration: Configuration
    selectedLanguage: string,
    tokenIsProvided: boolean,
    onLoadCallback: () => void,
    onErrorCallback: () => void
}

type State = {
    scriptsToBeLoaded: LoadScript[]
    message?: string
}

class CompanyRelations extends Component<Props, State> {
    constructor(props: Props) {
        super(props);
        this.state = {
            scriptsToBeLoaded: []
        };
    }

    componentDidMount() {
        this.setState({
            scriptsToBeLoaded: [
                ...this.state.scriptsToBeLoaded,
                { url: `${this.props.configuration.companyRelationsWebComponentBaseUrl}build/company-relations-admin.esm.js`, type: "module", nomodule: false },
                { url: `${this.props.configuration.companyRelationsWebComponentBaseUrl}build/company-relations-admin.js`, type: "text/javascript", nomodule: true},
            ]
        })
    }

    render() {
        const message = <Translation>{t => t(`Unfortunately we could not load "Company Relations".`)}</Translation>;

        return (
            <LoadableComponent
                loadPlaceholder={NoColContentLoadPlaceholder}
                errorPlaceholder={NoColContentLoadErrorPlaceholder}
                scriptsToBeLoaded={this.state.scriptsToBeLoaded}
                message={message}
                {... this.props}>
                <company-relations
                    language={this.props.selectedLanguage}
                    base-url={this.props.configuration.companyRelationsUserApiBaseUrl}
                    token-is-provided={this.props.tokenIsProvided}
                    show-remove-main-company={this.props.configuration.removeMainCompanyFeatureEnabled}
                >
                </company-relations>
            </LoadableComponent>
        )
    }
}

export default CompanyRelations;